import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-report-card',
  templateUrl: './report-card.component.html',
  styleUrls: ['./report-card.component.scss'],
  standalone: false
})
export class ReportCardComponent {

  @Input() icon: string = '';
  /** Ionicons name. When set it replaces the `icon` image. */
  @Input() ionIcon?: string;
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() disabled: boolean = false;
  /** Chevron a la derecha (hub de Administración). Apagado no cambia la card. */
  @Input() showChevron: boolean = false;

  @Output() clickHandler = new EventEmitter<void>();

  onClick() {
    if (!this.disabled) {
      this.clickHandler.emit();
    }
  }
}
